export default "__VITE_ASSET__b5c70c63__"